import {GetCitiesMedicalGuide} from 'domain/usecases';
import {RemoteGetCitiesMedicalGuide} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetCitiesMedicalGuide = (): GetCitiesMedicalGuide =>
	new RemoteGetCitiesMedicalGuide(
		makeBFFApiUrl(GuideFlowEndpoints.medicalGuideCities),
		makeAuthorizeHttpClientDecorator(),
	);
